// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file auth_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AuthResponseSchema, FcmTokenUpdateSchema, LoginOTPRequestSchema, LoginRequestSchema, MeResponseSchema, OTPRequestSchema, PasswordResetSchema, PasswordResetViaOtpSchema, RefreshTokenRequestSchema, TokenRequestSchema } from "./auth_pb";
import { file_auth } from "./auth_pb";
import type { EmptyMessageRequestSchema, MessageResponseSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { UserSchema } from "./user_pb";
import { file_user } from "./user_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file auth_service.proto.
 */
export const file_auth_service: GenFile = /*@__PURE__*/
  fileDesc("ChJhdXRoX3NlcnZpY2UucHJvdG8SCXJhY2Nvb25haSKCAgoXU2VsZlJlZ2lzdHJhdGlvblJlcXVlc3QSLgoScmVnaXN0cmF0aW9uX3Rva2VuGAEgAigJUhJyZWdpc3RyYXRpb25fdG9rZW4SHgoKZmlyc3RfbmFtZRgCIAIoCVIKZmlyc3RfbmFtZRIcCglsYXN0X25hbWUYAyACKAlSCWxhc3RfbmFtZRIiCgxwaG9uZV9udW1iZXIYBCABKAlSDHBob25lX251bWJlchINCgVlbWFpbBgFIAEoCRIQCghwYXNzd29yZBgGIAIoCRI0ChVkcml2ZXJfbGljZW5zZV9udW1iZXIYByABKAlSFWRyaXZlcl9saWNlbnNlX251bWJlcjLoBgoLQXV0aFNlcnZpY2USOwoFTG9naW4SFy5yYWNjb29uYWkuTG9naW5SZXF1ZXN0GhcucmFjY29vbmFpLkF1dGhSZXNwb25zZSIAEkYKBkxvZ291dBIeLnJhY2Nvb25haS5FbXB0eU1lc3NhZ2VSZXF1ZXN0GhoucmFjY29vbmFpLk1lc3NhZ2VSZXNwb25zZSIAEkkKCVByb3RlY3RlZBIeLnJhY2Nvb25haS5FbXB0eU1lc3NhZ2VSZXF1ZXN0GhoucmFjY29vbmFpLk1lc3NhZ2VSZXNwb25zZSIAEj0KAk1lEh4ucmFjY29vbmFpLkVtcHR5TWVzc2FnZVJlcXVlc3QaFS5yYWNjb29uYWkuTWVSZXNwb25zZSIAEkEKC1N0YXRpY1Rva2VuEhcucmFjY29vbmFpLlRva2VuUmVxdWVzdBoXLnJhY2Nvb25haS5BdXRoUmVzcG9uc2UiABJBCgpSZXF1ZXN0T1RQEhUucmFjY29vbmFpLk9UUFJlcXVlc3QaGi5yYWNjb29uYWkuTWVzc2FnZVJlc3BvbnNlIgASQQoITG9naW5PVFASGi5yYWNjb29uYWkuTG9naW5PVFBSZXF1ZXN0GhcucmFjY29vbmFpLkF1dGhSZXNwb25zZSIAEkcKDVJlc2V0UGFzc3dvcmQSGC5yYWNjb29uYWkuUGFzc3dvcmRSZXNldBoaLnJhY2Nvb25haS5NZXNzYWdlUmVzcG9uc2UiABJJCgxSZWZyZXNoVG9rZW4SHi5yYWNjb29uYWkuUmVmcmVzaFRva2VuUmVxdWVzdBoXLnJhY2Nvb25haS5BdXRoUmVzcG9uc2UiABJUChRGb3Jnb3RQYXNzd29yZFZpYU90cBIeLnJhY2Nvb25haS5QYXNzd29yZFJlc2V0VmlhT3RwGhoucmFjY29vbmFpLk1lc3NhZ2VSZXNwb25zZSIAEkwKE1NlbGZSZWdpc3RlclZpYUxpbmsSIi5yYWNjb29uYWkuU2VsZlJlZ2lzdHJhdGlvblJlcXVlc3QaDy5yYWNjb29uYWkuVXNlciIAEkkKDlVwZGF0ZUZjbVRva2VuEhkucmFjY29vbmFpLkZjbVRva2VuVXBkYXRlGhoucmFjY29vbmFpLk1lc3NhZ2VSZXNwb25zZSIAQgZaBC4vcGI", [file_auth, file_general, file_user]);

/**
 * @generated from message raccoonai.SelfRegistrationRequest
 */
export type SelfRegistrationRequest = Message<"raccoonai.SelfRegistrationRequest"> & {
  /**
   * @generated from field: required string registration_token = 1 [json_name = "registration_token"];
   */
  registrationToken: string;

  /**
   * @generated from field: required string first_name = 2 [json_name = "first_name"];
   */
  firstName: string;

  /**
   * @generated from field: required string last_name = 3 [json_name = "last_name"];
   */
  lastName: string;

  /**
   * @generated from field: optional string phone_number = 4 [json_name = "phone_number"];
   */
  phoneNumber: string;

  /**
   * @generated from field: optional string email = 5;
   */
  email: string;

  /**
   * @generated from field: required string password = 6;
   */
  password: string;

  /**
   * @generated from field: optional string driver_license_number = 7 [json_name = "driver_license_number"];
   */
  driverLicenseNumber: string;
};

/**
 * @generated from message raccoonai.SelfRegistrationRequest
 */
export type SelfRegistrationRequestJson = {
  /**
   * @generated from field: required string registration_token = 1 [json_name = "registration_token"];
   */
  registration_token?: string;

  /**
   * @generated from field: required string first_name = 2 [json_name = "first_name"];
   */
  first_name?: string;

  /**
   * @generated from field: required string last_name = 3 [json_name = "last_name"];
   */
  last_name?: string;

  /**
   * @generated from field: optional string phone_number = 4 [json_name = "phone_number"];
   */
  phone_number?: string;

  /**
   * @generated from field: optional string email = 5;
   */
  email?: string;

  /**
   * @generated from field: required string password = 6;
   */
  password?: string;

  /**
   * @generated from field: optional string driver_license_number = 7 [json_name = "driver_license_number"];
   */
  driver_license_number?: string;
};

/**
 * Describes the message raccoonai.SelfRegistrationRequest.
 * Use `create(SelfRegistrationRequestSchema)` to create a new message.
 */
export const SelfRegistrationRequestSchema: GenMessage<SelfRegistrationRequest, {jsonType: SelfRegistrationRequestJson}> = /*@__PURE__*/
  messageDesc(file_auth_service, 0);

/**
 * @generated from service raccoonai.AuthService
 */
export const AuthService: GenService<{
  /**
   * @generated from rpc raccoonai.AuthService.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof AuthResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AuthService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AuthService.Protected
   */
  protected: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AuthService.Me
   */
  me: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof MeResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AuthService.StaticToken
   */
  staticToken: {
    methodKind: "unary";
    input: typeof TokenRequestSchema;
    output: typeof AuthResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AuthService.RequestOTP
   */
  requestOTP: {
    methodKind: "unary";
    input: typeof OTPRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AuthService.LoginOTP
   */
  loginOTP: {
    methodKind: "unary";
    input: typeof LoginOTPRequestSchema;
    output: typeof AuthResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AuthService.ResetPassword
   */
  resetPassword: {
    methodKind: "unary";
    input: typeof PasswordResetSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AuthService.RefreshToken
   */
  refreshToken: {
    methodKind: "unary";
    input: typeof RefreshTokenRequestSchema;
    output: typeof AuthResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AuthService.ForgotPasswordViaOtp
   */
  forgotPasswordViaOtp: {
    methodKind: "unary";
    input: typeof PasswordResetViaOtpSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AuthService.SelfRegisterViaLink
   */
  selfRegisterViaLink: {
    methodKind: "unary";
    input: typeof SelfRegistrationRequestSchema;
    output: typeof UserSchema;
  },
  /**
   * Registers the caller's device for push. One token per user; a new token
   * replaces the old one. Drivers keep using DriverService.FirebaseNotifications.
   *
   * @generated from rpc raccoonai.AuthService.UpdateFcmToken
   */
  updateFcmToken: {
    methodKind: "unary";
    input: typeof FcmTokenUpdateSchema;
    output: typeof MessageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_auth_service, 0);

